import { Box, FormField, TextArea } from '@percent/lemonade'
import { RatingInput } from '../rating-input/rating-input'
import type { RatingQuestion, FreeTextQuestion } from '../../../dtos/survey.dto'
import { SurveyQuestionType } from '../../../dtos/survey.dto'
import { SurveyResponseFieldProps } from './survey-response-field.types'
import styles from './survey-response-field.module.scss'

type SurveyQuestionWithId =
  | (RatingQuestion & { id: string })
  | (FreeTextQuestion & { id: string })

export function SurveyResponseField({
  question,
  value,
  onChange,
  onBlur,
  disabled,
  error,
  touched,
  defaultPlaceholderText,
}: Readonly<SurveyResponseFieldProps>) {
  const showError = touched && error
  const questionWithId = question as SurveyQuestionWithId

  if (question.type === SurveyQuestionType.Rating) {
    const ratingValue = typeof value === 'number' ? value : undefined
    const config = question.config || { min: 1, max: 10 }

    return (
      <FormField
        label={question.label}
        necessity={question.required ? 'required' : 'optional'}
        status={showError ? 'danger' : 'default'}
        statusMessage={showError ? error : undefined}
      >
        <Box className={styles.Rating}>
          <RatingInput
            min={config.min}
            max={config.max}
            minLabel={config.minLabel}
            maxLabel={config.maxLabel}
            value={ratingValue}
            onChange={(value) => onChange(value)}
            onAfterChange={onBlur}
            disabled={disabled}
            name={`question-${questionWithId.id}`}
          />
        </Box>
      </FormField>
    )
  }

  if (question.type === SurveyQuestionType.FreeText) {
    const textValue = typeof value === 'string' ? value : ''

    return (
      <FormField
        label={question.label}
        necessity={question.required ? 'required' : 'optional'}
        status={showError ? 'danger' : 'default'}
        statusMessage={showError ? error : undefined}
        disabled={disabled}
      >
        <TextArea
          name={`question-${questionWithId.id}`}
          value={textValue}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={question.placeholder || defaultPlaceholderText}
        />
      </FormField>
    )
  }

  return null
}
